import {useMutation, useQueryClient} from '@tanstack/react-query';

import {deleteCountryCode} from '../api';
import {QUERY__COUNTRY_CODES} from '../queryKeys';

export const useDeleteCountryCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (countryCode: string) => deleteCountryCode(countryCode),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__COUNTRY_CODES]});
    },
  });
};
